module.exports = __webpack_public_path__ + "static/media/expand-icon.c03acf5c.svg";